import React from 'react'
import { useSelector } from 'react-redux'
import { APP_SERVICE, COLOR_NAME, ORDER_METHOD } from '../../constants'

import HeadInfoContainer from './HeadInfoContainer'
import DynamicColor from '../../components/common/dynamic-color'
import SearchBoxContainer from '../food/SearchBoxContainer'
import { isOrderAtRestaurant } from '../../utils'
import { getFullFileUrl } from '../../utils/formatData'
import { useHistory } from 'react-router-dom'
import useOrder from '../../hooks/useOrder'
import paths from '../../routes/paths'

import IconBack from '../../assets/icons/arrow-back-white.svg'

const HeaderContainer = ({ toggleSidebar, toggleAdrMgr }) => {
    const history = useHistory();
    const restaurantInfo = useSelector(state => state.RestaurantReducer);
    const { orderMethod } = useSelector(state => state.OrderReducer);
    const { foodsOrdered } = useOrder();
    const isContinueMode = (
        APP_SERVICE === ORDER_METHOD.QR_CODE &&
        !!foodsOrdered?.length &&
        history.location.pathname !== paths.cartDetail &&
        history.location.pathname !== paths.tableQRcodeSuccess
    );

    const { logoPath } = restaurantInfo || {}

    const handleLogoClick = () => {
        if (APP_SERVICE === ORDER_METHOD.QR_CODE && foodsOrdered?.length) {
            history.push(paths.tableQRcodeSuccess);
        }
    }

    return (
        <DynamicColor
            // style={{ backgroundColor: COLOR_NAME.LAYOUT_BG }}
            className="header-desk"
            id="header-desk"
        >
            <div className="container-fluid header-desk__container">
                <HeadInfoContainer
                    toggleSidebar={toggleSidebar}
                    toggleAdrMgr={toggleAdrMgr}
                />

                <div className="d-flex d-lg-none">
                    <div className="search">
                        {!isOrderAtRestaurant(orderMethod) && (
                            <div
                                className="btn-toggle-sidebar mr-4"
                                onClick={toggleSidebar}
                            >
                                <DynamicColor
                                    className="fas fa-bars heading-2 pointer"
                                    style={{ color: COLOR_NAME.LAYOUT_ICON }}
                                    tag="i"
                                />
                            </div>
                        )}

                        <div className="head-avt-res-mobile">
                            <img
                                src={isContinueMode ? IconBack : getFullFileUrl(logoPath)}
                                alt="banner"
                                onClick={handleLogoClick}
                            />
                        </div>

                        <SearchBoxContainer />
                    </div>
                </div>
            </div>
        </DynamicColor>
    )
}

export default HeaderContainer
